import type { AxiosInstance } from 'axios';

export interface BrandResponse {
  data: string[];
}

class BrandsService {
  private readonly endpoint: string;

  private readonly httpClient: AxiosInstance;

  constructor(entity: string, httpClient: AxiosInstance) {
    this.endpoint = `/v1/${entity}/brands`;
    this.httpClient = httpClient;
  }

  async list(): Promise<BrandResponse> {
    const response = await this.httpClient.get(`${this.endpoint}?page_size=99999`);
    return response.data;
  }
}

export const createBrandsService = (entity: string, httpClient: AxiosInstance) => new BrandsService(entity, httpClient);
